import React, { useState } from "react";
import { Box, Toolbar, useTheme, Tooltip, IconButton } from "@mui/material";
import { WebOutlined as WebIcon } from '@mui/icons-material';
import { AppHeader } from "./AppHeader";
import { AppDrawer } from "./AppDrawer";
import { DRAWER_WIDTH, DRAWER_WIDTH_MINI } from "./types";
import { Outlet } from "react-router-dom";
import PanelBar from "../panel-bar/PanelBar";

interface BaseLayoutProps {
  togglePreference?: () => void;
}

export function BaseLayout({ togglePreference }: BaseLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniMode, setMiniMode] = useState(false);
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleMiniMode = () => {
    setMiniMode(!miniMode);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <AppHeader
        onMenuClick={handleDrawerToggle}
        miniMode={miniMode}
        toggleMiniMode={toggleMiniMode}
      />
      <AppDrawer
        open={mobileOpen}
        onClose={handleDrawerToggle}
        miniMode={miniMode}
        toggleMiniMode={toggleMiniMode}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          width: {
            xs: "100%",
            sm: `calc(100% - ${miniMode ? DRAWER_WIDTH_MINI : DRAWER_WIDTH}px)`,
          },
          ml: {
            xs: 0,
            sm: `${miniMode ? DRAWER_WIDTH_MINI : DRAWER_WIDTH}px`,
          },
          transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          overflow: "hidden", // Prevent horizontal scrolling
        }}
      >
        <Toolbar sx={{ position: 'relative' }}> 
          {/* Layout toggle button */}
          {togglePreference && (
            <Tooltip title="Switch to top navigation">
              <IconButton 
                onClick={togglePreference}
                sx={{ 
                  position: 'absolute',
                  right: 16
                }}
              >
                <WebIcon />
              </IconButton>
            </Tooltip>
          )}
        </Toolbar>
        <Box
          sx={{
            width: "100%",
            height: "calc(100vh - 64px)", // Subtract AppBar height
            overflow: "auto", // Enable vertical scrolling
            p: { xs: 1, sm: 2, md: 3 }, // Responsive padding
          }}
        >
          <Outlet />
        </Box>
        <PanelBar />
      </Box>
    </Box>
  );
}

export default BaseLayout;